function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 1.951c-3.446 0-6.24 2.883-6.24 6.44 0 3.555 2.794 6.438 6.24 6.438s6.24-2.883 6.24-6.439S11.445 1.951 8 1.951zM.627 8.391C.627 4.186 3.927.78 8 .78c4.072 0 7.373 3.406 7.373 7.61C15.373 12.592 12.073 16 8 16 3.928 16 .627 12.593.627 8.39zM12.893.171a.555.555 0 01.802 0l2.139 2.208c.221.229.221.6 0 .828a.555.555 0 01-.802 0L12.892.999a.599.599 0 010-.828zM3.107.171a.555.555 0 00-.802 0L.166 2.38a.599.599 0 000 .828c.222.228.58.228.802 0L3.108.999a.599.599 0 000-.828z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.164 8.39c0-.323.254-.585.567-.585h4.538c.313 0 .567.262.567.585a.577.577 0 01-.567.586H5.73a.576.576 0 01-.567-.586z"
}));
function SvgCirculoconmenos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Circulo con menos.svg";
export { SvgCirculoconmenos as ReactComponent };